import { addDoc, collection } from "firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const CreateSport = async (SportObject, uid, SchoolID) => {
  try {
    const SportsCollection = collection(db, "Sports");

    const data = HelperForMetaData({
      ...SportObject,
      uid: uid,
      SchoolID: SchoolID,
    });
    await addDoc(SportsCollection, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default CreateSport;
